import { useState, useEffect } from 'react';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { CfopAtualizar, CfopCadastrar } from '../../../../routes/RoutesNames';
import CfopController from '../../../../controllers/CfopController';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';
import { formatarData } from '../../../../shared/utils/helpers/date';
import { toast } from 'react-toastify';
import { Button } from '../../../../shared/components/button/Button';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Loader } from '../../../../shared/components/Loader';
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  cfop_id: number;
  cfo_id: number;
  cfo_descricao: string;
  tipo: string;
  data_inicio: Date;
  data_fim: Date;
  BtnMenu?: JSX.Element;
  handleOpenModalSearchProduct: () => void;
}

export default function Cfop() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const tableColumns: Column[] = [
    { id: 'Codigo', label: 'Código', minWidth: 0, align: 'center' },
    { id: 'Descricao', label: 'Descrição', minWidth: 0, align: 'center' },
    { id: 'Tipo', label: 'Tipo', minWidth: 0, align: 'center' },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];
  const [tableRows, setTableRows] = useState<Row[]>([]);
  const fields = [
    { name: 'cfop_id', type: 'text', label: 'Código' },
    { name: 'cfop_tipo', type: 'text', label: 'Tipo' },
    { name: 'cfop_descricao', type: 'text', label: 'Descrição' },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
  ]
  /* 
  const itemsTipo = [
    { value: 'T', label: 'Todos' },
    { value: 'E', label: 'Entrada' },
    { value: 'S', label: 'Saída' },
  ];
  */
  const initialValues = {
    cfop_id: null,
    cfop_tipo: 'T',
    cfop_descricao: '',
    Data_Inicio: formatarData(new Date()),
    Data_Fim: formatarData(new Date()),
  };

  const handleNavigation = async (): Promise<void> => {
    navigate(CfopCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(CfopAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      console.log('item.Id', item.cfop_id);
      navigate(CfopAtualizar.replace(':id', item.cfo_id.toString()));
    }
  };

  const handleDeleteItem = async (cfo_id: number) => {
    const request: any = { Cfop_Id: cfo_id };
    setLoading(true);
    const response = await CfopController.Excluir(request);
    setLoading(false);
    if (response.StatusCode === 204 || response.StatusCode === 200) {
      toast('CFOP excluído com sucesso!', {
        type: 'success',
      });
      await handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir CFOP!', {
        type: 'error',
      });
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    const Response = await CfopController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.forEach((item: Row) => {
        DataRows.push({
          BtnEditar: (
            <Button
              onClick={() => handleEditItem(item)}
              aria-label='edit'
              variant='info'
              title='Editar'
              iconStart={<Icon.Edit />}
            />
          ),
          BtnExcluir: (
            <Button
              onClick={() => handleDeleteItem(item.cfop_id)}
              aria-label='delete'
              variant='error'
              title='Excluir'
              iconStart={<Icon.Delete />}
            />
          ),
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: 'Editar' },
                {
                  onClick: () => handleDeleteItem(item.cfo_id),
                  menu: 'Excluir', confirmar: `Excluir o CFOP "${item.cfo_descricao ?? ''}"? Esta ação não pode ser desfeita.`,
                },
              ]}
            />
          ),
          Codigo: item.cfo_id,
          Descricao: item.cfo_descricao,
          Tipo: item.tipo,
          DataInicio: item.data_inicio,
          DataFim: item.data_fim,
        });
      });

      setTableRows(DataRows);
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
      setTableRows([]);
    } else {
      toast(Response?.Data, {
        type: 'success',
      });
      setTableRows([]);
    }
  };

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return (
    <Box>
      <HeaderComponent text={'CFOP'}
        ButtonRight={
          <Button
            className={''}
            variant='success'
            onClick={handleNavigation}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} />
      <Loader loading={loading}>
        <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Codigo);}}/>
      </Loader>
    </Box>
  );
}
